import customAxios from '../interceptors';

const getTenants = () => {
  return customAxios.get(`${process.env.REACT_APP_API_URL}/tenants`);
}

export default getTenants;
